import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './About.css';

const BriefcaseIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2"/>
    <path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/>
  </svg>
);
const CodeIcon2 = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/>
  </svg>
);
const StarIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);
const ArchIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/>
  </svg>
);
const LayoutIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <line x1="3" y1="9" x2="21" y2="9"/>
    <line x1="9" y1="21" x2="9" y2="9"/>
  </svg>
);
const UsersIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 00-3-3.87"/>
    <path d="M16 3.13a4 4 0 010 7.75"/>
  </svg>
);
const MotionIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <path d="M8 12l2 2 4-4"/>
  </svg>
);
const TrendIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 7l-7.5 7.5-4-4L1 21"/>
    <path d="M17 7h6v6"/>
    <rect x="3" y="3" width="7" height="5" rx="1"/>
  </svg>
);
const DownloadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
    <polyline points="7 10 12 15 17 10"/>
    <line x1="12" y1="15" x2="12" y2="3"/>
  </svg>
);

import { usePortfolio } from '../context/PortfolioContext';

const CONTACT_EMAIL = 'talhakhaliddhariwal@gmail.com';

export default function About() {
  const navigate = useNavigate();
  const { data, loading } = usePortfolio();

  if (loading || !data) {
    return <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-dark)', color: 'white' }}>Loading...</div>;
  }
  const { skills, experience, cvLink } = data;
  return (
    <div className="about-page page-enter">
      <Navbar />

      {/* HERO */}
      <section className="about-hero">
        <div className="about-hero-inner">
          <div className="about-hero-img">
            <div className="about-img-placeholder">
              <img className="about-main-image" src="/images/hero-image.png" alt="Talha Khalid" />
            </div>
          </div>
          <div className="about-hero-content">
            <p className="about-label">About Talha Developments</p>
            <h1>Building Digital <span className="purple">Experiences</span> with Purpose.</h1>
            <p className="about-hero-desc">
              I am Talha Khalid, a developer and designer with 2+ years of hands-on experience delivering modern websites, apps, and brand-focused digital products. I combine clean design with practical engineering to build solutions that look great and perform even better.
            </p>
            <div className="about-hero-btns">
              <a href={cvLink} download className="btn-primary" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none' }}><DownloadIcon /> Download CV</a>
              <button className="btn-outline" onClick={() => navigate('/projects')}>Portfolio</button>
            </div>
          </div>
        </div>
      </section>

      {/* JOURNEY */}
      <section className="journey-section">
        <div className="ab-container">
          <div className="section-header">
            <h2>The Professional Journey</h2>
            <div className="section-divider" />
          </div>
          <div className="timeline">
            {experience.map(item => {
              let IconComp = <BriefcaseIcon />;
              // Try to map icon loosely based on role string if needed, or keep static. For simplicity, keeping static or mapping simple
              return (
              <div key={item.id || item.date} className="timeline-item">
                <div className="tl-dot">{IconComp}</div>
                <div className="tl-body">
                  <p className="tl-date">{item.date}</p>
                  <p className="tl-role">{item.role}</p>
                  <p className="tl-desc">{item.desc}</p>
                </div>
              </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* TECHNICAL PROWESS */}
      <section className="prowess-section">
        <div className="ab-container">
          <div className="prowess-grid">
            <div className="prowess-left">
              <h2>Technical<br /><span className="purple">Prowess</span></h2>
              <p>I continuously sharpen my skillset to deliver production-ready experiences that blend strong visuals with clean, maintainable code.</p>
              <div className="prowess-tags">
                {['React', 'Next.js', 'TypeScript', 'Tailwind CSS', 'Figma', 'Node.js'].map(t => (
                  <span key={t} className="tag">{t}</span>
                ))}
              </div>
            </div>
            <div className="skills-grid">
              {skills.map(s => {
                let IconComp = <ArchIcon />;
                if (s.iconType === 'layout') IconComp = <LayoutIcon />;
                if (s.iconType === 'users') IconComp = <UsersIcon />;
                if (s.iconType === 'motion') IconComp = <MotionIcon />;
                if (s.iconType === 'trend') IconComp = <TrendIcon />;
                return (
                <div key={s.name} className="skill-card">
                  <div className="skill-icon">{IconComp}</div>
                  <p className="skill-name">{s.name}</p>
                  <div className="card-divider" />
                  <p className="skill-desc">{s.desc}</p>
                </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* PHILOSOPHY */}
      <section className="philosophy-section">
        <div className="philosophy-quote-bg">"</div>
        <div className="philosophy-inner">
          <p className="philosophy-label">My Philosophy</p>
          <p className="philosophy-quote">
            "I craft digital experiences where design communicates clearly, code performs flawlessly, and content tells a compelling story."
          </p>
          <p className="philosophy-body">
            Every detail is intentional — built to create impact, earn trust, and drive real results.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <div className="ab-container" style={{ textAlign: 'center' }}>
          <h2>Let's build something <span className="purple">remarkable</span> together.</h2>
          <a href={`mailto:${CONTACT_EMAIL}`} className="cta-email">{CONTACT_EMAIL}</a>
          <div className="cta-socials">
            <a href="https://www.linkedin.com/in/talha-khalid-81ba97266/" target="_blank" rel="noreferrer">LinkedIn</a>
            <span className="sep">|</span>
            <a href="https://www.instagram.com/talha_._khalid" target="_blank" rel="noreferrer">Instagram</a>
            <span className="sep">|</span>
            <a href="https://github.com/Talha-Khalid-D" target="_blank" rel="noreferrer">GitHub</a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
